import { makeStyles } from '@material-ui/core';
import { newShadows } from 'muiTheme/config/palette';

export default makeStyles((theme) => ({
    btn_wrapper: {},
    propKeepBtn: {
        padding: '10px 16px',
        boxShadow: newShadows.xs,
        borderRadius: '8px',
        height: '44px',
        '&>.MuiButton-label': {
            gap: '8px',
            lineHeight: 2.4,
        },
    },
    keep_tooltip: {
        backgroundColor: theme.palette.grayVariants[900],
        color: theme.palette.default.main,
        borderRadius: '8px',
        padding: '8px 12px',
    },
    tooltip_text: {
        fontWeight: 700,
    },
}));
